var _defs, _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSelectedCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_7_6",
    "data-name": "Component 7 \\u2013 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.24,
    height: 15,
    viewBox: "0 0 17.24 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_363",
    "data-name": "Rectangle 363",
    width: 17.24,
    height: 15,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    transform: "translate(15 15) rotate(180)",
    fill: "none",
    stroke: "#006ad9",
    strokeWidth: 1.25,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.625,
    width: 13.75,
    height: 13.75,
    rx: 3.375,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3718",
    "data-name": "Group 3718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3717",
    "data-name": "Group 3717",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3552",
    "data-name": "Path 3552",
    d: "M5.92,8.957a1.49,1.49,0,0,0-1.053-.436H3.716L6.465,11.27l.884-.884Z",
    fill: "#006ad9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3553",
    "data-name": "Path 3553",
    d: "M13.75,6.539V11A2.75,2.75,0,0,1,11,13.75H4A2.75,2.75,0,0,1,1.25,11V4A2.75,2.75,0,0,1,4,1.25h7a2.748,2.748,0,0,1,2.657,2.078c.341-.3.679-.6,1.018-.9A4,4,0,0,0,11,0H4A4,4,0,0,0,0,4v7a4,4,0,0,0,4,4h7a4,4,0,0,0,4-4V4.74l-.862.863a1.321,1.321,0,0,0-.388.936",
    fill: "#006ad9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3554",
    "data-name": "Path 3554",
    d: "M6.465,11.27,17.24.5H16.089a1.491,1.491,0,0,0-1.053.436L5.581,10.386Z",
    fill: "#006ad9"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedCheckbox);
export default __webpack_public_path__ + "static/media/selectedCheckbox.91edafbeed325f81495248b5dd6ef819.svg";
export { ForwardRef as ReactComponent };